<template>
  <tr
    v-bind:key="result.id">
    <td>{{ result.id }}</td>
    <td :id="'instrument-proj' + result.id">
      {{ result.projectId }}
      <b-tooltip :target="'instrument-proj' + result.id">
        {{result.projectName === null ? 'N/A' : result.projectName}}
      </b-Tooltip>
    </td>
    <td>{{ result.instrumentType }}</td>
    <td>{{ result.staffLeadName }}</td>
    <td>{{ result.instrumentStatus }}</td>
    <td>{{ result.localityName || 'N/A' }}</td>
    <td>{{ result.executedDate | dateStringNullIsNA }}</td>
    <td>
      <router-link
        :to="{ name: 'projectInstrument', params: {
        project_id: result.projectId,
        id: result.id }}"
        class="btn btn-secondary btn-sm">
        View
      </router-link>
    </td>
  </tr>
</template>
<script>

export default {
  name: 'InstrumentSearchResultRow',
  props: {
    result: {
      type: Object,
    },
  },
};
</script>
